export enum ButtonSkins {
  DEFAULT,
  BADGE,
  CIRCLE,
  TRANSPARENT,
  ICON
}
